import { defineMessages } from 'react-intl'

const audioMessages = {
  AudioPlayer: defineMessages({
    playRate05x: {
      id: 'audioPlayer.AudioPlayer.playRate05x',
      defaultMessage: '0.5 倍速',
    },
    playRate075x: {
      id: 'audioPlayer.AudioPlayer.playRate075x',
      defaultMessage: '0.75 倍速',
    },
    playRate10x: {
      id: 'audioPlayer.AudioPlayer.playRate10x',
      defaultMessage: '1 倍速',
    },
    playRate125x: {
      id: 'audioPlayer.AudioPlayer.playRate125x',
      defaultMessage: '1.25 倍速',
    },
    playRate15x: {
      id: 'audioPlayer.AudioPlayer.playRate15x',
      defaultMessage: '1.5 倍速',
    },
    playRate175x: {
      id: 'audioPlayer.AudioPlayer.playRate175x',
      defaultMessage: '1.75 倍速',
    },
    playRate20x: {
      id: 'audioPlayer.AudioPlayer.playRate20x',
      defaultMessage: '2 倍速',
    },
    playRate40x: {
      id: 'audioPlayer.AudioPlayer.playRate40x',
      defaultMessage: '4 倍速',
    },
    playlist: {
      id: 'audioPlayer.AudioPlayer.playlist',
      defaultMessage: '播放清單',
    },
  }),
}

export default audioMessages
